// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__19ECs","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3HXOY"};